import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { MainMenu, MainMenuProps } from "./components/MainMenu";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { saga } from "./saga";
import { IMenuState } from "./types";

export { createReloadMenuAction } from "./actions";

export const menuModule: ApplicationStatefulModule<typeof NAME, Reducer<IMenuState>, MainMenuProps> = {
    NAME,
    Container: MainMenu,
    reducer,
    saga,
};
